import { css } from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';

export const locationSectionStyles = css`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 30px 40px;
  }
`;
